<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { Head } from '@inertiajs/inertia-vue3'
import { onMounted, onUnmounted } from 'vue'
import { brandHasWebsite, brandIsV2, brandHasExtendFlag } from '@/Shared/helper-contents.js'
import { replaceS3path } from '@/Shared/helper.js'
import V1 from '@/Pages/Brand/DetailV1' // 通常ブランド
import V2 from '@/Pages/Brand/DetailV2' // adiron, hala, pacsafe など
import V3 from '@/Pages/Brand/DetailV3' // sdg, troley, sevencycle など
import V4 from '@/Pages/Brand/DetailV4' // rocky
import usePref from '@/Shared/usePref.js'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'

const props = defineProps({
  brandInfo: Array,
  myCategories: Object,
  myCategoriesColumns: Object,
  myProducts: Array,
  myNews: Array,
  v3year: String,
  v3category: String,
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})

onUnmounted(() => {})
</script>

<template>
  <div class="">
    <template v-if="brandInfo.length > 0">
      <Head :title="brandInfo[0].brandNameLocal + ' - 取り扱いブランド'">
        <meta name="description" :content="brandInfo[0].brandIntroLead" />
        <meta property="og:title" :content="brandInfo[0].brandNameLocal + ' - 取り扱いブランド'" />
        <meta property="og:description" :content="brandInfo[0].brandIntroLead" />
        <meta property="og:image" :content="replaceS3path(brandInfo[0].brandThumb)" />
      </Head>
      <div v-if="brandInfo.length >= 1">
        <div v-if="brandHasWebsite(brandInfo[0])">
          <a :href="brandInfo[0].localWebURL" target="_blank" class="ext-link">ウェブサイトはこちらから</a>
        </div>

        <div v-else>
          <div v-if="brandIsV2(brandInfo[0]) && brandHasExtendFlag(brandInfo[0])">
            <V4 v-if="brandInfo[0].brandSlug == 'rocky_mountain_bicycles'" :brand-info="brandInfo" :my-categories="myCategories" :my-categories-columns="myCategoriesColumns" :my-products="myProducts" :pref="pref" :my-news="myNews" />
            <V3 v-else :brand-info="brandInfo" :my-categories="myCategories" :my-categories-columns="myCategoriesColumns" :pref="pref" :my-news="myNews" />
          </div>
          <div v-else-if="brandIsV2(brandInfo[0])">
            <V2 :brand-info="brandInfo" :my-categories="myCategories" :my-products="myProducts" :pref="pref" :my-news="myNews" />
          </div>
          <div v-else>
            <V1 :brand-info="brandInfo" />
          </div>
        </div>
      </div>
      <div v-else>not found</div>
    </template>
    <template v-else>
      <div class="grid place-items-center">
        <div class="detail-container">
          <h2 class="page-title !pb-0">
            Brands
            <small>ブランド</small>
          </h2>
          <div class="my-16 sm:my-20 md:my-24 lg:my-28">
            <p class="text-[14px] sm:text-[15px] lg:text-[16px] text-center pb-10">
              該当のブランドはありません。
            </p>
            <ButtonRounded class="min-w-[200px] mx-auto" text="ブランド一覧を見る" url="/brands" icon="arrow" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
